import React, { useState, useEffect } from "react";
import Alert from "react-bootstrap/Alert";

const AlertMessage = ({ type, message, onClose }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      if (onClose) onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  if (!show) return null;

  return (
    <Alert
      variant={type}
      dismissible
      onClose={() => {
        setShow(false);
        if (onClose) onClose();
      }}
    >
      {message}
    </Alert>
  );
};

export default AlertMessage;
